 <svg [attr.height]="height" [attr.width]="width" [attr.alt]="'#'+href" xmlns="http://www.w3.org/2000/svg">
     <use [attr.xlink:href]="'#'+href" [attr.height]="height" [attr.width]="width"></use>
 </svg>